import Login from '@features/authentication/components/Login/Login'

const LoginPage = () => {
  return <Login />
}

export default LoginPage
